var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden"},[_vm._v("현재의 화면을 종료 합니다.")])}
var staticRenderFns = []

export { render, staticRenderFns }